export default __webpack_public_path__ + "static/media/alter-image.7236cdaa.png";